<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-4">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <h1 class="h4 ls-tight">Crear nuevo estado</h1>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="hstack gap-2 justify-content-end">
                                <button @click="CREATE()" type="button" class="btn btn-h btn-success px-3">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid max-w-screen-md vstack gap-3">
                    <div>
                        <label class="input-title">Nombre</label>
                        <input type="text" class="form-control form-control-sm" v-model="data.name" :class="errors.name ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.name" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Etiqueta</small>
                        <input type="text" class="form-control form-control-sm" v-model="data.labels" :class="errors.labels ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.labels" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Notificar</small>
                        <v-select v-model="data.notify"
                            :items="actions"
                            hide-details
                            class="form-control form-control-sm"
                            :class="errors.notify ? 'is-invalid' : ''">
                        </v-select>
                        <small class="invalid-feedback" v-for="(error, index) in errors.notify" :key="index">{{ error }}</small>
                    </div>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
import { mapGetters } from 'vuex'
export default{
    data(){
        return{
            data: {},
            errors: {},
            count: 0,
        }
    },
    computed: {
        ...mapGetters([
            'actions',
        ])
    },
    methods:{
        CREATE: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                setTimeout(() => {
                    axios({url: '/states', method: 'POST', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$router.push({ name: 'StateIndex' })
                    })
                    .catch((err) => {
                        if(err.response.status === 422){
                            vue.errors = err.response.data
                        }else if(err.response.status === 402){
                            vue.$swal({ toast: true, icon: 'error', title: err.response.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }else{
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        }
    }
}
</script>